import Hero from "./Hero";
import Services from "./Services";
import About from "./About";
import Footer from "./Footer";
import NavBar from "./NavBar"
import './Home.css';


function Home() {
  return (
    <div className="page-wrapper">
  <NavBar currentPage="home" />
      <Hero />
      <Services />
      <About />
      <Footer />
    </div>
  );
}

export default Home;
